import { Component, OnInit, TemplateRef, ViewChild, NgZone } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { FormMode, RatingProfile} from 'src/app/_models/models';
import { AlertService, AlertOptions, AlertTypes, AlertMessage, AlertSeverity  } from 'src/app/alert/alert.component';
// import { forEach } from '@angular/router/src/utils/collection';
// import { CodegenComponentFactoryResolver } from '@angular/core/src/linker/component_factory_resolver';
import { RatingProfilesService } from 'src/app/services/api/rating-profiles.service';
import { CarriersService } from 'src/app/services/api/carriers.service';
import { FormBuilder, FormControl, FormGroup, NgForm, FormArray } from '@angular/forms';
import { Router, RouterOutlet } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { SnackbarComponent } from 'src/app/Shared Components/snackbar/snackbar.component';
import { MessagePopupComponent } from 'src/app/Shared Components/message-popup/message-popup.component';
import { CommonService } from 'src/app/services/common.service';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { take, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-administration-rating-profile-component',
  templateUrl: './rating-profile.component.html',
  styleUrls: ['./rating-profile.component.scss']
})

// https://stackoverflow.com/questions/55617772/angular-7-multiple-outlets-error-cannot-activate-an-already-activated-outle
export class RatingProfileComponent implements OnInit {
  @ViewChild(RouterOutlet) outlet: RouterOutlet;
  @ViewChild('callAPIDialog') callAPIDialog: TemplateRef<any>;
  @ViewChild('autosize') autosize: CdkTextareaAutosize;
  ratingProfiles: RatingProfile[];
  displayedColumns: string[] = ['ProfileName', 'CreatedDate', 'Actions'];
  public tabledata : any[] = [];

  mode: FormMode = FormMode.None;
  formModes = FormMode;
  model: RatingProfile = new RatingProfile();
  showdiag: boolean = false;
  diagmsg: string;
  selectedRateFile: string;
  ratingProfileName: string;

  availableServices: any[];
  availableAccessorials = [
    {
      label: 'Fuel Surcharge',
      value: 'FUEL'
    },
    {
      label: 'Delivery Area Surcharge',
      value: 'DAS'
    },
    {
      label: 'Extended Delivery Area Surcharge',
      value: 'EDAS'
    },
    {
      label: 'Residential Surcharge',
      value: 'RES'
    },
    {
      label: 'Saturday Delivery',
      value: 'SAT'
    },
    {
      label: 'Oversized',
      value: 'OVERSIZE'
    },
    {
      label: 'Additional Handling',
      value: 'ADDL'
    },
    {
      label: 'Indirect Signature Required',
      value: 'POD'
    },
    {
      label: 'Direct Signature Required',
      value: 'POD_DIRECT'
    },
    {
      label: 'Adult Signature Required',
      value: 'POD_ADULT'
    }
  ];
  availablePackagingTypes = [{
    label: 'Envelopes',
    value: 'ENVELOPE'
  }];

  ratingProfileDataSource = new MatTableDataSource<any>();

  engines: SelectItem[] = [
    { label: "FX", value: "FX" },
    { label: "GLS", value: "GLS" },
    { label: "UPS", value: "UPS" },
    { label: "Better Trucks", value: "BetterTrucks" },
    { label: "TLS Parcel", value: "TLS" },
    { label: "LSO", value: "LSO" },
    { label: "EasyPost", value: "EP" },
    { label: "GORI", value: "GORI" }
  ];

  constructor(private carrierService: CarriersService, private ratingProfileService: RatingProfilesService
    , private alert: AlertService,
    public dialog: MatDialog, private _snackBar: MatSnackBar, private router: Router, private comm: CommonService, private _ngZone: NgZone, private fb: FormBuilder) {
  }
  @ViewChild(MatPaginator,{ static: false }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  serviceDiscountsForm: FormGroup;
  accessorialDiscountsForm: FormGroup;
  dimDivisorsForm: FormGroup;

  serviceDiscountsFilterForm: FormGroup;

  ngOnInit() {
    this.serviceDiscountsForm = this.fb.group({
      serviceDiscounts: this.fb.array([])
    });
    this.accessorialDiscountsForm = this.fb.group({
      accessorialDiscounts: this.fb.array([])
    });
    //this.rateFilesForm.get('rateFiles').valueChanges.subscribe(row => { console.log('rateFiles', row) });
    this.dimDivisorsForm = this.fb.group({
      dimDivisors: this.fb.array([])
    });

  }
  ngAfterViewInit() {
    this.loadListData();
    this.ratingProfileDataSource.paginator = this.paginator;
  }
  openDialog() {    
    let dialogRef = this.dialog.open(this.callAPIDialog);
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result !== 'no') {
          const enabled = "Y"
          console.log(result);
        } else if (result === 'no') {
          console.log('User clicked no.');
        }
      }
    });
}
  onSend(form: NgForm){
  if(form.status === 'INVALID')
  {
    // display error in your form
  }else{
      console.log(form.value)
      this.dialog.closeAll(); // Close opened diaglo
    // do whatever you want to do with your data
}

}
  async loadListData() {
    this.ratingProfiles = null;
    this.ratingProfileService.getAll(null).subscribe(
      r => {
        this.ratingProfiles = new Array<RatingProfile>();
        for(let ratingProfile of r){
          this.ratingProfiles.push(ratingProfile);
        }
        this.tabledata = this.ratingProfiles;
        this.ratingProfileDataSource = new MatTableDataSource(this.ratingProfiles);
        this.ratingProfileDataSource.paginator = this.paginator;

      },
      e => {
        this.openSnackBar('Failed to load profile list', 'error');
      });
    this.carrierService.getAllServices().subscribe(
      r => {
        this.availableServices = r;

      },
      e => {
        this.openSnackBar('Failed to load profile list', 'error');
      });

  }
  onChangedPageSize($event){
    console.log($event);
  }
  private _filter(value: any): any[] {
    const filterValue = value.toLowerCase();
    return this.ratingProfiles.filter(option => option.profileName.toLowerCase().includes(filterValue));
  }
  triggerResize() {
    // Wait for changes to be applied, then trigger textarea resize.
    this._ngZone.onStable.pipe(take(1))
      .subscribe(() => this.autosize.resizeToFitContent(true));
  }

  get serviceDiscounts(): FormArray {
    return this.serviceDiscountsForm.get('serviceDiscounts') as FormArray;
  }
  get accessorialDiscounts(): FormArray {
    return this.accessorialDiscountsForm.get('accessorialDiscounts') as FormArray;
  }
  get dimDivisors(): FormArray {
    return this.dimDivisorsForm.get('dimDivisors') as FormArray;
  }
  serviceDiscountSubscriptions: Subscription[] = [];
  accessorialDiscountSubscriptions: Subscription[] = [];
  dimDivisorSubscriptions: Subscription[] = [];
  serviceDiscountFilterSubscription: Subscription;

  onSubmit(form: any) {
    switch (this.mode) {
      case FormMode.Find: {
        this.ratingProfileService.getAll(this.ratingProfileName).subscribe(
          r => {
            this.ratingProfiles = new Array<RatingProfile>();
            for(let ratingProfile of r){
              this.ratingProfiles.push(ratingProfile);
            }
            this.tabledata = this.ratingProfiles;
            this.ratingProfileDataSource = new MatTableDataSource(this.ratingProfiles);
            this.ratingProfileDataSource.paginator = this.paginator;
          },
          e => {
            this.openSnackBar('Failed to carrier list', 'error');
          });
        break;
      }
      case FormMode.New: {
        if (form.invalid) {
        } else {
          this.post(form);
        }
        break;
      }
      case FormMode.Edit: {
        if (form.invalid) {

        } else {
          this.put(form);
        }
        break;
      }
      case FormMode.Del: {
        this.delete(form);
        break;
      }
      default: {
        break;
      }
    }
  }
    post(form: any) {
    //debugger;
        this.ratingProfileService.create(this.model).subscribe(
      r => {
      form.resetForm();
      this.resetForm();
      this.loadListData();
      if ( r == null) {
        this.openSnackBar('RatingProfile with same name already exists', 'success');
      } else {
        this.openSnackBar('Saved sucessfully', 'success');
      }
      },
      e => function (ex) {
        this.openSnackBar('Failed to save', 'error');
      }
    );
  }

  put(form: any) {
    this.ratingProfileService.update(this.model).subscribe(result => {
      form.resetForm();
      this.resetForm();
      this.loadListData();
      this.openSnackBar('Updated sucessfully', 'success');
    }, error => {
      this.openSnackBar('Failed to update', 'error');

    });
  }

  delete(p: any) {
    this.dialog
    .open(MessagePopupComponent, {
      data: {
        title: 'Delete Rating Profile',
        confirmText: 'Delete',
        cancelText: 'Cancel',
        message: 'Are you sure you want to DELETE the selected Rating Profile?',
      },
    })
    .afterClosed()
    .subscribe((res) => {
      if (res) {
        this.ratingProfileService.delete(p.id).subscribe(result => {
          this.resetForm();
          this.loadListData();
          this.openSnackBar('Deleted sucessfully', 'success');
        }, error => {
          this.openSnackBar('Failed to delete', 'error');
        });
        }
    });

  }

  resetForm() {
    this.loadListData();
    this.mode = FormMode.None;
    this.model.selected = false;
    this.model = new RatingProfile();
    if (this.serviceDiscountSubscriptions != null)
      this.serviceDiscountSubscriptions.forEach(x => x.unsubscribe());
    if (this.accessorialDiscountSubscriptions != null)
      this.accessorialDiscountSubscriptions.forEach(x => x.unsubscribe());
    if (this.dimDivisorSubscriptions != null)
      this.dimDivisorSubscriptions.forEach(x => x.unsubscribe());
  }

  showFind() {
    this.mode = FormMode.Find;
    this.model.selected = false;
    this.model = new RatingProfile();
    if (this.serviceDiscountSubscriptions != null)
      this.serviceDiscountSubscriptions.forEach(x => x.unsubscribe());
    if (this.accessorialDiscountSubscriptions != null)
      this.accessorialDiscountSubscriptions.forEach(x => x.unsubscribe());
    if (this.dimDivisorSubscriptions != null)
      this.dimDivisorSubscriptions.forEach(x => x.unsubscribe());
  }

  showNew() {
    if (this.serviceDiscountFilterSubscription != null)
      this.serviceDiscountFilterSubscription.unsubscribe();
    if (this.serviceDiscountSubscriptions != null)
      this.serviceDiscountSubscriptions.forEach(x => x.unsubscribe());
    //debugger;
    this.mode = FormMode.New;
    this.model.selected = false;
    this.model = new RatingProfile();
    this.ratingProfiles = null;

    //Subscribe filters for service discounts
    this.serviceDiscountsFilterForm = this.fb.group({
      serviceType: "",
      packaging: ""
    })
    this.serviceDiscountFilterSubscription = this.serviceDiscountsFilterForm.valueChanges
      .pipe(
        debounceTime(500), // avoid firing on every keystroke
        distinctUntilChanged()
      )
      .subscribe(value => {
        this.getServiceDiscounts();
      });

    this.serviceDiscountsForm.reset();
    this.accessorialDiscountsForm.reset();
    this.dimDivisorsForm.reset();
  }

  showEdit(p: any) {
    this.getRatingProfile(p);
  }

  copy(p: any) {

    this.ratingProfileService.copy(p.id).subscribe(
      r => {
        this.ratingProfiles.push(r)
        this.ratingProfileDataSource.data.push(r);
        this.showEdit(r);
      },
      e => {
        this.openSnackBar('Failed to copy rating profile', 'error');
      });
  }

  showDel(p: any) {
    this.mode = FormMode.Del;
    this.model.selected = false;
    this.model = p;
    this.model.selected = true;
  }

  getRatingProfile(model) {
    this.ratingProfileService.get(model.id).subscribe(
      r => {
        if (this.serviceDiscountFilterSubscription != null)
          this.serviceDiscountFilterSubscription.unsubscribe();
        if (this.serviceDiscountSubscriptions != null)
          this.serviceDiscountSubscriptions.forEach(x => x.unsubscribe());
        //debugger;
        this.mode = FormMode.Edit;
        this.model.selected = false;
        this.model = r;
        this.model.selected = true;
        localStorage.setItem('ratingProfileId', r.id.toString());

        //Subscribe filters for service discounts
        this.serviceDiscountsFilterForm = this.fb.group({
          serviceType: "",
          packaging: ""
        })
        this.serviceDiscountFilterSubscription = this.serviceDiscountsFilterForm.valueChanges
          .pipe(
            debounceTime(500), // avoid firing on every keystroke
            distinctUntilChanged()
          )
          .subscribe(value => {
            this.getServiceDiscounts();
          });


        this.setServiceDiscounts(r.serviceDiscounts);
        this.setAccessorialDiscounts(r);
        this.setDIMDivisors(r);
      },
      e => {
        this.openSnackBar('Failed to get carrier rate files for the selected carrier', 'error');
      });
  }


  //Service Discounts
  private getServiceDiscounts() {
    this.ratingProfileService.getServiceDiscounts(this.model.id, this.serviceDiscountsFilterForm.value.serviceType, this.serviceDiscountsFilterForm.value.packaging).subscribe(
      r => {
        this.setServiceDiscounts(r);
      },
      e => {
        this.openSnackBar('Failed to get service discount list', 'error');
      });

  }
  private setServiceDiscounts(serviceDiscounts) {
    if (this.serviceDiscountSubscriptions != null)
      this.serviceDiscountSubscriptions.forEach(x => x.unsubscribe());
    let flag = true;
    for (let serviceDiscount_selectItem of serviceDiscounts) {

      serviceDiscount_selectItem.zones = serviceDiscount_selectItem.zone;
    }
    const serviceDiscountFGs = serviceDiscounts.map(element => this.fb.group(element));
    const serviceDiscountFormArray = this.fb.array(serviceDiscountFGs);
    this.serviceDiscountsForm.setControl('serviceDiscounts', serviceDiscountFormArray);
    this.subscribeServiceDiscounts();
  }
  addServiceDiscount() {
    let newRow = this.fb.group({
      id: new FormControl(0),
      serviceType: new FormControl(""),
      packaging: new FormControl("CUSTOM"),
      minWeight: new FormControl(0),
      maxWeight: new FormControl(0),
      zones: new FormControl(""),
      discountPercentage: new FormControl(0),
      minimumCharge: new FormControl(0),
      ratingProfileId: new FormControl(this.model.id),
      ratingProfile: new FormControl(null),
      selected: new FormControl(false)
    });
    this.serviceDiscounts.push(newRow);
    this.subscribeServiceDiscount(this.serviceDiscounts.controls[this.serviceDiscounts.length - 1] as FormControl, this.serviceDiscounts.length - 1);
  }
  saveServiceDiscount(element, index) {
    let req = {
      Id: element.id,
      ServiceType: element.serviceType,
      Packaging: element.packaging,
      MinWeight: element.minWeight,
      MaxWeight: element.maxWeight,
      Zone: element.zones,
      DiscountPercentage: element.discountPercentage,
      MinimumCharge: element.minimumCharge,
      RatingProfileId: element.ratingProfileId
    }

    //this.ClientdataSource.paginator = this.paginator;
    this.ratingProfileService.saveServiceDiscount(req).subscribe(
      r => {
        //this.openSnackBar('Saved sucessfully', 'success');
        if (element.id == 0) {
          element.id = r.id;
          (this.serviceDiscounts.controls[index] as FormGroup).controls.id.setValue(r.id);
        }
      },
      e => {
        this.openSnackBar('Failed to save service discount', 'error');
      });

  }
  deleteServiceDiscount(index) {
    var data = this.serviceDiscounts.controls[index].value

    if (data.id > 0) {
    this.dialog
      .open(MessagePopupComponent, {
        data: {
          title: 'Delete Service Discount',
          confirmText: 'Delete',
          cancelText: 'No',
          message: 'Are you sure you want to delete this service discount?',
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.ratingProfileService.deleteServiceDiscount(data.id).subscribe(result => {
            this.openSnackBar('Service discount deleted successfully', 'success');
            this.serviceDiscounts.removeAt(index);
          }, error => {
            this.openSnackBar('Failed to delete service discount', 'error');
          });
        }
      });
    }
    else {
      this.serviceDiscounts.removeAt(index);
    }
  }
  getPackagingValue(index) {
    return this.serviceDiscounts.controls[index].value.packaging;
  }
  subscribeServiceDiscounts(): void {
    this.serviceDiscounts.controls.forEach((control, index) => {
      this.subscribeServiceDiscount(control as FormControl, index);
    });
  }
  subscribeServiceDiscount(control: FormControl, index: number): void {
    const sub = control.valueChanges
      .pipe(
        debounceTime(1500), // avoid firing on every keystroke
        distinctUntilChanged()
      )
      .subscribe(value => {
        this.saveServiceDiscount(value, index);
      });

    this.serviceDiscountSubscriptions.push(sub);
  }


  //Accessorial Discounts
  private setAccessorialDiscounts(p) {
    let flag = true;
    for (let accessorialDiscount_selectItem of p.accessorialDiscounts) {

      accessorialDiscount_selectItem.zones = accessorialDiscount_selectItem.zone;

    }
    const accessorialDiscountFGs = p.accessorialDiscounts.map(element => this.fb.group(element));
    const accessorialDiscountFormArray = this.fb.array(accessorialDiscountFGs);
    this.accessorialDiscountsForm.setControl('accessorialDiscounts', accessorialDiscountFormArray);
    this.subscribeAccessorialDiscounts();
  }
  addAccessorialDiscount() {
    let newRow = {
      id: new FormControl(0),
      serviceType: new FormControl(""),
      accessorialCode: new FormControl(""),
      minWeight: new FormControl(0),
      maxWeight: new FormControl(0),
      zones: new FormControl(""),
      discountPercentage: new FormControl(0),
      flatRateOverride: new FormControl(0),
      ratingProfileId: new FormControl(this.model.id),
      ratingProfile: new FormControl(null),
      selected: new FormControl(false)
    };
    this.accessorialDiscounts.push(this.fb.group(newRow));
    this.subscribeAccessorialDiscount(this.accessorialDiscounts.controls[this.accessorialDiscounts.length - 1] as FormControl, this.accessorialDiscounts.length - 1);
  }
  saveAccessorialDiscount(element, index) {

    let req = {
      Id: element.id,
      ServiceType: element.serviceType,
      AccessorialCode: element.accessorialCode,
      MinWeight: element.minWeight,
      MaxWeight: element.maxWeight,
      Zone: element.zones,
      DiscountPercentage: element.discountPercentage,
      FlatRateOverride: element.flatRateOverride,
      RatingProfileId: element.ratingProfileId
    }

    //this.ClientdataSource.paginator = this.paginator;
    this.ratingProfileService.saveAccessorialDiscount(req).subscribe(
      r => {
        //this.openSnackBar('Saved sucessfully', 'success');
        if (element.id == 0) {
          element.id = r.id;
          (this.accessorialDiscounts.controls[index] as FormGroup).controls.id.setValue(r.id);
        }
      },
      e => {
        this.openSnackBar('Failed to save accessorial discount', 'error');
      });

  }
  deleteAccessorialDiscount(index) {
    var data = this.accessorialDiscounts.controls[index].value;

    if (data.id > 0) {
    this.dialog
      .open(MessagePopupComponent, {
        data: {
          title: 'Delete Accessorial Discount',
          confirmText: 'Delete',
          cancelText: 'No',
          message: 'Are you sure you want to delete this discount?',
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.ratingProfileService.deleteAccessorialDiscount(data.id).subscribe(result => {
            this.openSnackBar('Accessorial discount deleted successfully', 'success');
            this.accessorialDiscounts.removeAt(index);
          }, error => {
            this.openSnackBar('Failed to delete accessorial discount', 'error');
          });
        }
      });
    }
    else {
      this.accessorialDiscounts.removeAt(index);
    }
  }
  subscribeAccessorialDiscounts(): void {
    this.accessorialDiscounts.controls.forEach((control, index) => {
      this.subscribeAccessorialDiscount(control as FormControl, index);
    });
  }
  subscribeAccessorialDiscount(control: FormControl, index: number): void {
    const sub = control.valueChanges
      .pipe(
        debounceTime(1500), // avoid firing on every keystroke
        distinctUntilChanged()
      )
      .subscribe(value => {
        this.saveAccessorialDiscount(value, index);
      });

    this.accessorialDiscountSubscriptions.push(sub);
  }



  //DIM Divisors
  private setDIMDivisors(p) {
    let flag = true;
    for (let dimDivisor_selectItem of p.dimDivisors) {


    }
    const dimDivisorFGs = p.dimDivisors.map(element => this.fb.group(element));
    const dimDivisorFormArray = this.fb.array(dimDivisorFGs);
    this.dimDivisorsForm.setControl('dimDivisors', dimDivisorFormArray);
    this.subscribeDIMDivisors();
  }
  addDIMDivisor() {
    let newRow = {
      id: new FormControl(0),
      serviceType: new FormControl(""),
      dimDivisor: new FormControl(0),
      ratingProfileId: new FormControl(this.model.id),
      ratingProfile: new FormControl(null),
      selected: new FormControl(false)
    };
    this.dimDivisors.push(this.fb.group(newRow));
    this.subscribeDIMDivisor(this.dimDivisors.controls[this.dimDivisors.length - 1] as FormControl, this.dimDivisors.length - 1);
  }
  saveDIMDivisor(element, index) {

    let req = {
      Id: element.id,
      ServiceType: element.serviceType,
      DIMDivisor: element.dimDivisor,
      RatingProfileId: element.ratingProfileId
    }

    //this.ClientdataSource.paginator = this.paginator;
    this.ratingProfileService.saveDIMDivisor(req).subscribe(
      r => {
        //this.openSnackBar('Saved sucessfully', 'success');
        if (element.id == 0) {
          element.id = r.id;
          (this.dimDivisors.controls[index] as FormGroup).controls.id.setValue(r.id);
        }
      },
      e => {
        this.openSnackBar('Failed to save DIM divisor', 'error');
      });

  }
  deleteDIMDivisor(index) {
    var data = this.dimDivisors.controls[index].value;

    if (data.id > 0) {
      this.dialog
        .open(MessagePopupComponent, {
          data: {
            title: 'Delete DIM Divisor',
            confirmText: 'Delete',
            cancelText: 'No',
            message: 'Are you sure you want to delete this DIM divisor?',
          },
        })
        .afterClosed()
        .subscribe((res) => {
          if (res) {
            this.ratingProfileService.deleteDIMDivisor(data.id).subscribe(result => {
              this.openSnackBar('DIM divisor deleted successfully', 'success');
              this.dimDivisors.removeAt(index);
            }, error => {
              this.openSnackBar('Failed to delete DIM divisor', 'error');
            });
          }
        });
    }
    else {
      this.dimDivisors.removeAt(index);
    }
  }
  subscribeDIMDivisors(): void {
    this.dimDivisors.controls.forEach((control, index) => {
      this.subscribeDIMDivisor(control as FormControl, index);
    });
  }
  subscribeDIMDivisor(control: FormControl, index: number): void {
    const sub = control.valueChanges
      .pipe(
        debounceTime(1500), // avoid firing on every keystroke
        distinctUntilChanged()
      )
      .subscribe(value => {
        this.saveDIMDivisor(value, index);
      });

    this.dimDivisorSubscriptions.push(sub);
  }

  openSnackBar(message: string, messageType:'error'|'success'|'notification') {
    let config = new MatSnackBarConfig();
    config.data = {
      message: message,
      type:messageType
    };
    config.duration = environment.messageTimeOut;
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.panelClass =messageType;
    this._snackBar.openFromComponent(SnackbarComponent, config);
  }

  close(){
    this.dialog.closeAll();
    this.ratingProfileDataSource = new MatTableDataSource(this.tabledata);
    this.ratingProfileDataSource.paginator = this.paginator;
   }

}
